const SYSTEM_NAME = 'Akademia Przyszłości'
const SYSTEM_SHORTCUT = 'AP'
const PAYMENT_TITLE = 'DAROWIZNA – AKADEMIA PRZYSZŁOŚCI'
const SYSTEM_ACCUSATIVE = 'Akademię Przyszłości'
const SYSTEM_GENITIVE = 'Akademii Przyszłości'
const LOGO_NAME = 'ap-logo.png'
const EMAIL_ICON_NAME = 'email-blue.svg'
const FOOTER_LOGO_NAME = 'logo-ap.svg'
const SYSTEM_URL_PRIVACY_POLICY = 'https://www.wiosna.org.pl/polityka-prywatnosci/'
const SYSTEM_URL_REGULATIONS = 'https://www.wiosna.org.pl/regulamin-serwisu/'
const SYSTEM_PAYMENT_LOGO = 'przelewy24_logo_2022_navy_blue.svg'
const SYSTEM_PAYMENT_METHOD = 'Przelewy24'
const SYSTEM_PAYMENT_LOGO_STRIPE = 'stripe-navy-blue.svg'
const SYSTEM_PAYMENT_METHOD_STRIPE = 'Stripe'
const SYSTEM_SAFE_PAYMENT_ICON = 'safe-payment-icon-navy-blue.svg'
const SYSTEM_SAFE_PAYMENT_TEXT = 'Bezpieczne płatności'
const SYSTEM_FACEBOOK_URL = 'http://facebook.com/akademia.przyszlosci'
const SYSTEM_INSTAGRAM_URL = 'https://www.instagram.com/akademiaprzyszlosci'
const SYSTEM_YOUTUBE_URL = 'http://www.youtube.com/user/TVakademii'
const SUMMARY_LOGO_NAME = 'ap-logo.png'
const SUMMARY_FOOTER_EMAIL = 'indeks@wiosna.org.pl'
const THANK_YOU_TEXT_FIRST = 'za Twoją wpłatę i zaangażowanie<br> w Akademię.'
const THANK_YOU_TEXT_SECOND = 'Dzięki wsparciu takich osób jak Ty,<br> Dzieci mogą zawalczyć o wiarę w siebie<br> i lepszą przyszłość!'
const FB_SHARE_LINK = 'https://www.facebook.com/sharer/sharer.php?u=https%3A//akademiaprzyszlosci.org.pl/pomagaj-akademii/'
const KEY1_SKU = 15
const KEY2_SKU = 11
const KEY3_SKU = 13
const KEY4_SKU = 14
const KEY5_SKU = 16
const SHOW_BLIK_HINT = false

export default {
    SYSTEM_NAME: SYSTEM_NAME,
    SYSTEM_SHORTCUT: SYSTEM_SHORTCUT,
    PAYMENT_TITLE: PAYMENT_TITLE,
    SYSTEM_ACCUSATIVE: SYSTEM_ACCUSATIVE,
    SYSTEM_GENITIVE: SYSTEM_GENITIVE,
    LOGO_NAME: LOGO_NAME,
    SYSTEM_URL_PRIVACY_POLICY: SYSTEM_URL_PRIVACY_POLICY,
    SYSTEM_URL_REGULATIONS: SYSTEM_URL_REGULATIONS,
    EMAIL_ICON_NAME: EMAIL_ICON_NAME,
    FOOTER_LOGO_NAME: FOOTER_LOGO_NAME,
    SYSTEM_PAYMENT_LOGO: SYSTEM_PAYMENT_LOGO,
    SYSTEM_PAYMENT_METHOD: SYSTEM_PAYMENT_METHOD,
    SYSTEM_PAYMENT_LOGO_STRIPE: SYSTEM_PAYMENT_LOGO_STRIPE,
    SYSTEM_PAYMENT_METHOD_STRIPE: SYSTEM_PAYMENT_METHOD_STRIPE,
    SYSTEM_SAFE_PAYMENT_ICON: SYSTEM_SAFE_PAYMENT_ICON,
    SYSTEM_SAFE_PAYMENT_TEXT: SYSTEM_SAFE_PAYMENT_TEXT,
    SYSTEM_FACEBOOK_URL: SYSTEM_FACEBOOK_URL,
    SYSTEM_INSTAGRAM_URL: SYSTEM_INSTAGRAM_URL,
    SYSTEM_YOUTUBE_URL: SYSTEM_YOUTUBE_URL,
    SUMMARY_LOGO_NAME: SUMMARY_LOGO_NAME,
    SUMMARY_FOOTER_EMAIL: SUMMARY_FOOTER_EMAIL,
    THANK_YOU_TEXT_FIRST: THANK_YOU_TEXT_FIRST,
    THANK_YOU_TEXT_SECOND: THANK_YOU_TEXT_SECOND,
    FB_SHARE_LINK: FB_SHARE_LINK,
    KEY1_SKU: KEY1_SKU,
    KEY2_SKU: KEY2_SKU,
    KEY3_SKU: KEY3_SKU,
    KEY4_SKU: KEY4_SKU,
    KEY5_SKU: KEY5_SKU,
    SHOW_BLIK_HINT: SHOW_BLIK_HINT
}
